import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BaseModal from '../../../../common/ModalWindows/BaseModal';
import Terms from './Terms';
import { PreferenceLabel } from '../../../../Form/Preference';
import styles from '../JobPreferences/JobPreferences.module.scss';
import { maxMobileSize, maxMoneyValue, validationMessages } from '../../../../../utils/constants';
import { useWindowSize } from '../../../../../utils/hooks';
import ActionsButton from '../../../../common/buttons/ActionsButton/ActionsButton';

export function TermsWrapper(props) {
  const { userRates, updateUserRates } = props;

  const size = useWindowSize();

  const initialErrorsState = {
    hourly: '',
    daily: '',
    annual: ''
  };

  const [editTerms, setEditTerms] = useState(false);
  const [userRatesLocaly, setUserRatesLocaly] = useState(userRates);
  const [validationErrors, setValidationErrors] = useState(initialErrorsState);
  const { t } = useTranslation();

  useEffect(() => {
    setUserRatesLocaly(userRates);
  }, [userRates]);

  const validateForm = (values) => {
    let initialValidation = {
      hourly: '',
      daily: '',
      annual: ''
    };

    if (Number(values.Hourly) > maxMoneyValue)
      initialValidation = { ...initialValidation, hourly: validationMessages(t).MAX_MONEY_VALUE };
    if (Number(values.Daily) > maxMoneyValue)
      initialValidation = { ...initialValidation, daily: validationMessages(t).MAX_MONEY_VALUE };
    if (Number(values.Annual) > maxMoneyValue)
      initialValidation = { ...initialValidation, annual: validationMessages(t).MAX_MONEY_VALUE };

    setValidationErrors(initialValidation);

    return !Object.values(initialValidation).some((value) => !!value);
  };

  const confirmTerms = () => {
    const isFormValid = validateForm(userRatesLocaly);
    if (isFormValid) {
      setEditTerms(false);
      updateUserRates(userRatesLocaly);
    }
  };

  return (
    <div className={styles.preferenceFields}>
      <PreferenceLabel primary={t('dashboard.modal.terms')} />
      <div className={styles.action}>
        <ActionsButton activityName="edit" clickHandler={() => setEditTerms(true)} />
        <BaseModal
          title={t('dashboard.modal.edit.terms')}
          open={editTerms}
          fullscreen={size.width < maxMobileSize}
          closeHandler={() => {
            setEditTerms(false);
            setUserRatesLocaly(userRates);
            setValidationErrors(initialErrorsState);
          }}
          confirmHandler={confirmTerms}
        >
          <Terms userRates={userRatesLocaly} updateUserRates={setUserRatesLocaly} errors={validationErrors} />
        </BaseModal>
      </div>
      <div className={styles.chipsContainer}>
        <Terms userRates={userRatesLocaly} updateUserRates={() => false} disabled />
      </div>
    </div>
  );
}
